import { render, staticRenderFns } from "./Modalidade.vue?vue&type=template&id=779026ac&scoped=true&"
import script from "./Modalidade.vue?vue&type=script&lang=js&"
export * from "./Modalidade.vue?vue&type=script&lang=js&"
import style0 from "./Modalidade.vue?vue&type=style&index=0&id=779026ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779026ac",
  null
  
)

export default component.exports